import { render } from "./CompanyLeadsView.vue?vue&type=template&id=567d3d4b&scoped=true"
import script from "./CompanyLeadsView.vue?vue&type=script&lang=js"
export * from "./CompanyLeadsView.vue?vue&type=script&lang=js"

import "./CompanyLeadsView.vue?vue&type=style&index=0&id=567d3d4b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567d3d4b"]])

export default __exports__